import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';

import { CircularProgress } from '@mui/material';
import { useMst } from '../../../models/rootModel';
import { useAnalytics } from '../../../utils/analytics';
import { LoaderDiv } from '../../styledComponent/Boxes.style';
import { PickAProgramContent } from './PickAProgramContent';
import { useHandleSearchParamsPlan } from '../../../hooks/useHandleSearchParamsPlan.hook';
import { DEFAULT_PLAN_KEY, PickAProgramProps } from './PickAProgram.types';

export const PickAProgram = observer((props: PickAProgramProps) => {
  const { UserPayment, UserProgress, UserDiscoveryResponse } = useMst();
  const { isActive, nextStep, stepName } = props;
  const analytics = useAnalytics();

  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    if (isActive) {
      analytics.track('view pick a product step', {
        stepName,
        referringUrl: document.referrer,
        segment: UserDiscoveryResponse.segment,
        healingProgram: true,
      });
      window.scrollTo(0, 0);
    }
  }, [isActive, analytics, stepName, UserDiscoveryResponse.segment]);

  useEffect(() => {
    if (isActive && !UserPayment.checkIfPlansAreLoaded()) {
      UserPayment.getStripePlans();
    }
  }, [UserPayment, isActive]);

  useHandleSearchParamsPlan({
    isActive,
    nextStep,
    setInitialLoading,
  });

  const pickAProgram = (pp: string, id: string) => {
    analytics.track('click product to buy', {
      sku: id,
      stepName,
      segment: UserDiscoveryResponse.segment,
      healingProgram: true,
      withKlarna: UserPayment.withKlarna
    });
    UserPayment.setChosenPlanPosition(pp);
  };

  const plan = UserPayment.getChoosenPlan();

  const handleSubmit = (position: string) => {
    if (!plan) {
      UserPayment.setChosenPlanPosition(DEFAULT_PLAN_KEY);
    }

    analytics.track('submit product to buy', {
      sku: UserPayment?.chosenPlanPosition && UserPayment.stripePlans[UserPayment.chosenPlanPosition].id,
      stepName,
      segment: UserDiscoveryResponse.segment,
      position,
      healingProgram: true,
      withKlarna: UserPayment.withKlarna
    });

    nextStep();
  };

  const handleAbsoluteBack = () => {
    UserProgress.back(props.goToNamedStep);
  };

  if (initialLoading) {
    return null;
  }

  return (
    <>
      {UserPayment.planPositions.length && UserPayment.payWallMeta ? (
        <PickAProgramContent
          {...props}
          handleAbsoluteBack={handleAbsoluteBack}
          handleSubmit={handleSubmit}
          pickAProgram={pickAProgram}
          planPositions={UserPayment.planPositions}
          data={UserPayment.payWallMeta}
        />
      ) : (
        <LoaderDiv>
          <CircularProgress />
        </LoaderDiv>
      )}
    </>
  );
});
